function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// ----------------------------------------------------------------------------
// Product Gallery Module: Product Video
// ----------------------------------------------------------------------------
// The ProductVideo class adds video player functionality to the product gallery.
// - Supports YouTube, Vimeo, and HTML5 video players (HTML5 preferred in most cases)
// ----------------------------------------------------------------------------
// Customization:
// - Enable `videoController--html5` to support HTML5 video players.
// - Enable `videoController--youtube` to support YouTube video players.
// - Enable `videoController--vimeo` to support Vimeo video players.
// ----------------------------------------------------------------------------
// Event Listeners:
// - 'productForm:gallery:init'                  → Listens for the gallery initalization
//                                                 to begin initalizing the videos
// - 'productForm:gallery:featureSlider:changed' → Listens for the feature slider to
//                                                 trigger events when the slide changes
//                                                 if a video is present.
// ----------------------------------------------------------------------------
// Event Triggers:
// - 'productForm:gallery:video:init'            → Fires when a video is found to be initialized
// - 'productForm:gallery:video:mediaVisible'    → Fires when a video slide is visible
// - 'productForm:gallery:video:mediaHidden'     → Fires when a video slide is hidden
// ----------------------------------------------------------------------------
// Gotchas:
// - Each video slide needs a `data-product-media-type-video` attribute and `mediaId`
//   reference to indicate it's a video slide.
// - Videos are only initialized if they have a valid `iframe` or `video` element inside.
// - This class does not directly initalize, play, or pause videos, rather it triggers
//   events for the `videoController` module(s) to handle accordingly.
// - When a slide changes, the previous video is hidden, and the new one is marked as visible.
// - The `removeSectionVideos` method ensures that videos are properly destroyed when a section
//   is removed.
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Helpers
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import './videoController--html5';
// import './videoController--youtube';
// import './videoController--vimeo';

// -------------------------------------
// Product Video Class
// -------------------------------------

class ProductVideo {
  constructor(iamProductGallery) {
    _defineProperty(this, "videos", {});
    _defineProperty(this, "ATTRIBUTES", {
      enableVideoLooping: 'enable-video-looping',
      videoId: 'video-id'
    });
    this.iamProductGallery = iamProductGallery;
    var videoContainers = iamProductGallery.querySelectorAll('[data-product-media-type-video]');
    videoContainers.forEach(videoContainer => {
      this.initVideo(videoContainer, iamProductGallery.sectionId);
    });
    iamotaEventHandler.subscribe('productForm:gallery:featureSlider:changed', this.onSlideChanged.bind(this), {
      context: this.iamProductGallery,
      source: "productVideo.js"
    });
  }
  initVideo(videoContainer, sectionId) {
    if (!videoContainer) return;
    var videoElement = videoContainer.querySelector('iframe, video');
    var mediaId = videoContainer.dataset.mediaId;
    if (!videoElement) return;
    this.videos[mediaId] = {
      mediaId,
      sectionId,
      container: videoContainer,
      element: videoElement
    };
    iamotaEventHandler.trigger('productForm:gallery:video:init', {
      ProductVideo: this,
      video: this.videos[mediaId]
    }, {
      context: this.iamProductGallery
    });
  }
  removeSectionVideos(sectionId) {
    for (var videoId in this.videos) {
      var video = this.videos[videoId];
      if (video.sectionId === sectionId) {
        if (video.player) video.player.destroy();
        delete this.videos[videoId];
      }
    }
  }
  onSlideChanged(_ref) {
    var _previousMedia$datase, _currentMedia$dataset;
    var swiper = _ref.swiper;
    var previousSlideIndex = swiper.previousIndex;
    var currentSlideIndex = swiper.activeIndex;
    var currentMedia = this.iamProductGallery.querySelector(".product__feature-image .swiper-slide[data-index=\"".concat(currentSlideIndex, "\"] .product-single__media-wrapper"));
    var previousMedia = this.iamProductGallery.querySelector(".product__feature-image .swiper-slide[data-index=\"".concat(previousSlideIndex, "\"] .product-single__media-wrapper"));
    if (previousMedia !== null && previousMedia !== void 0 && (_previousMedia$datase = previousMedia.dataset) !== null && _previousMedia$datase !== void 0 && _previousMedia$datase.mediaId) {
      iamotaEventHandler.trigger('productForm:gallery:video:mediaHidden', {
        mediaId: previousMedia.dataset.mediaId
      }, {
        context: this.iamProductGallery
      });
    }
    if (currentMedia !== null && currentMedia !== void 0 && (_currentMedia$dataset = currentMedia.dataset) !== null && _currentMedia$dataset !== void 0 && _currentMedia$dataset.mediaId) {
      iamotaEventHandler.trigger('productForm:gallery:video:mediaVisible', {
        mediaId: currentMedia.dataset.mediaId
      }, {
        context: this.iamProductGallery
      });
    }
  }
}
var productVideoControllers = [];
iamotaEventHandler.subscribe('productForm:gallery:init', _ref2 => {
  var iamProductGallery = _ref2.iamProductGallery;
  productVideoControllers.push(new ProductVideo(iamProductGallery));
}, {
  source: "productVideo.js"
});
export default productVideoControllers;